import React from 'react';
import classnames from 'classnames';
import './ConnectAndContribute.scss';
import { LINK_FORUM, LINK_HELP_CENTER, LINK_PROJECT_HUB } from '../../utils/constants';

interface ConnectAndContributeProps {
  noMargin?: boolean;
  noTopSpace?: boolean;
  showContactButton?: boolean;
  githubLink?: string;
  forumLink?: string;
  helpCenterLink?: string;
  projectHubLink?: string;
}

export default function ConnectAndContribute({
  noMargin,
  noTopSpace,
  showContactButton,
  githubLink,
  forumLink,
  helpCenterLink,
  projectHubLink,
}: ConnectAndContributeProps): React.ReactElement {
  return (
    <div className={classnames('connect', { 'connect__no-margin': noMargin, 'connect__no-top-space': noTopSpace })}>
      <h4>Connect and Contribute</h4>
      <div className="connect__links">
        <div className={classnames('connect__box', { 'connect__box--no-sales': !showContactButton })}>
          <a
            href={projectHubLink ? LINK_PROJECT_HUB + `?value=${projectHubLink}` : LINK_PROJECT_HUB}
            className="connect__link"
            target="_blank"
            rel="noreferrer"
          >
            Project Hub
          </a>
          <a href={githubLink ? githubLink : 'https://github.com/arduino/docs-content'} className="connect__link" target="_blank" rel="noreferrer">
            GitHub Repository
          </a>
          <a href={forumLink ? LINK_FORUM + 'c' + forumLink : LINK_FORUM} className="connect__link" target="_blank" rel="noreferrer">
            Forum
          </a>
        </div>
        <div className={classnames('connect__box', { 'connect__box--no-sales': !showContactButton })}>
          <a href="/certifications/" className="connect__link">
            Product Compliance
          </a>
          <a
            href={helpCenterLink ? LINK_HELP_CENTER + 'hc/en-us/search?utf8=%E2%9C%93&query=' + helpCenterLink : LINK_HELP_CENTER}
            className="connect__link"
            target="_blank"
            rel="noreferrer"
          >
            Help Center
          </a>
          <a
            href="https://support.arduino.cc/hc/en-us/articles/10598087334428-Trademarks-Licensing"
            className="connect__link"
            target="_blank"
            rel="noreferrer"
          >
            Trademarks & Licensing
          </a>
          {/* Community hided until the time we have a community page. */}
          {/* <a href="https://forum.arduino.cc/" className="connect__links--item" target="_blank" rel="noreferrer">
          Community
        </a> */}
          {/* <a href="https://wiki-content.arduino.cc/en/Guide/Troubleshooting" className="connect__link" target="_blank" rel="noreferrer">
            Troubleshooting
          </a> */}
        </div>
        {showContactButton && (
          <div className="connect__box--sales">
            <p>Interested in growing your business with us?</p>
            <a href="https://www.arduino.cc/pro/contact-us/">Contact Sales</a>
          </div>
        )}
      </div>
    </div>
  );
}
